'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createIconComponent = require('./utils/createIconComponent');

var _createIconComponent2 = _interopRequireDefault(_createIconComponent);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconExpandDiagonal2 = (0, _createIconComponent2.default)({ fillContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M15.5 16.249a1.25 1.25 0 0 0 .884-2.134l-6.5-6.5a1.25 1.25 0 1 0-1.769 1.768l6.5 6.5a1.246 1.246 0 0 0 .885.366zM1 24h4a1 1 0 0 0 .707-1.707l-.939-.94a.249.249 0 0 1 0-.353l4.616-4.616a1.25 1.25 0 1 0-1.768-1.768L3 19.231a.25.25 0 0 1-.354 0l-.939-.939A1 1 0 0 0 0 19v4a1 1 0 0 0 1 1zM23.383 5.923A1 1 0 0 0 24 5V1a1 1 0 0 0-1-1h-4a1 1 0 0 0-.707 1.707l.939.939a.25.25 0 0 1 0 .354l-4.116 4.115a1.25 1.25 0 0 0 1.768 1.768L21 4.767a.25.25 0 0 1 .354 0l.939.939A1 1 0 0 0 23 6a.987.987 0 0 0 .383-.077z' })
  ), lightContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M15.5 15.499a.5.5 0 0 1-.354-.146l-6.5-6.5A.5.5 0 0 1 9 7.999a.5.5 0 0 1 .354.146l6.5 6.5a.5.5 0 0 1-.354.854zM.5 23.999a.496.496 0 0 1-.5-.5v-4a.5.5 0 0 1 1 0v2.793l7.646-7.646a.5.5 0 1 1 .708.707l-7.646 7.646H4.5a.5.5 0 0 1 0 1h-4zM15.5 8.999a.5.5 0 0 1-.354-.854L22.292.999H19.5a.5.5 0 0 1 0-1h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.706l-7.146 7.146a.496.496 0 0 1-.354.147z' })
  ), regularContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M.75 23.999a.755.755 0 0 1-.26-.047l-.022-.008A.756.756 0 0 1 0 23.249v-6.75a.75.75 0 0 1 1.5 0v4.939l6.97-6.97a.744.744 0 0 1 1.06 0 .744.744 0 0 1 0 1.06l-6.97 6.97H7.5a.75.75 0 0 1 0 1.5H.75zM15 9.749a.743.743 0 0 1-.53-.22c-.142-.141-.22-.33-.22-.53s.078-.389.22-.53l6.97-6.97H16.5a.75.75 0 0 1 0-1.5h6.75a.735.735 0 0 1 .293.06.75.75 0 0 1 .4.404l.01.026a.739.739 0 0 1 .047.26v6.75a.75.75 0 0 1-1.5 0V2.56l-6.97 6.97a.746.746 0 0 1-.53.219zM15.75 16.499a.743.743 0 0 1-.53-.22l-7.5-7.5c-.142-.141-.22-.33-.22-.53s.078-.389.22-.53c.141-.142.33-.22.53-.22s.389.078.53.22l7.5 7.5a.752.752 0 0 1 0 1.061.746.746 0 0 1-.53.219z' })
  ), height: undefined, width: undefined, viewBox: "0 0 24 24" });
IconExpandDiagonal2.displayName = 'IconExpandDiagonal2';
exports.default = IconExpandDiagonal2;